// components/FilesSection.jsx
import React, { useRef } from "react";

const formatFileSize = (bytes) => {
  if (typeof bytes !== "number") return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const FilesSection = ({
  archivos,
  cargando,
  manejarArchivos,
  eliminarArchivo,
  descargarArchivo,
  obtenerIcono,
  editMode,
}) => {
  const inputRef = useRef(null);

  return (
    <div
      className="calculador-archivos-container"
      style={{
        margin: 0,
        gap: 0,
        ...(!editMode ? { pointerEvents: "none", opacity: 0.9 } : {}),
      }}
    >
      <h1 className="calculador-title">Archivos</h1>
      <p className="archivos-subtitle">
        Sube tus imágenes o documentos, se enviarán como archivos adjuntos
      </p>

      <div className="upload-area" onClick={() => inputRef.current.click()}>
        <i className="bi bi-cloud-upload upload-icon"></i>
        <p className="upload-text">
          <span className="upload-click">Click para subir</span> ó arrastrar
        </p>
        <p className="upload-size">
          Puedes cargar un máximo de 10 archivos, cada uno de 3 MB
        </p>
      </div>
      <input
        type="file"
        multiple
        ref={inputRef}
        style={{ display: "none" }}
        onChange={manejarArchivos}
      />

      {cargando && (
        <p style={{ fontSize: "14px", color: "#888" }}>Cargando archivo...</p>
      )}

      {archivos.length > 0 && (
        <div className="archivos-list">
          {archivos.map((file) => {
            const sizeText = formatFileSize(file.size);
            const dateObj = file.creadoEn?.toDate
              ? file.creadoEn.toDate()
              : new Date(file.creadoEn);
            const dateText = dateObj.toLocaleDateString();

            return (
              <div className="archivo-item success" key={file.id}>
                <i className="bi bi-check-circle archivo-success-icon" />
                <div className="archivo-info">
                  <p className="archivo-name">Cargado con Éxito</p>
                  <p className="archivo-details">
                    {file.nombre} | {sizeText} | {dateText}
                  </p>
                </div>
                <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                  <button
                    onClick={() => descargarArchivo(file.url, file.nombre)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="bi bi-download"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </button>
                  <button
                    onClick={() => eliminarArchivo(file.id, file.path)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#dc3545",
                    }}
                  >
                    <i className="bi bi-trash" style={{ fontSize: "20px" }}></i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilesSection;
